/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AvailableIndividualCompetencyDevelopmentPathsDto } from '../models';
// @ts-ignore
import type { ChangeEmployeeIndividualDevelopmentPathAcceptanceStatusDto } from '../models';
// @ts-ignore
import type { CreateCompetencyDevelopmentPathDto } from '../models';
// @ts-ignore
import type { CreateCompetencyDevelopmentPathResponseDto } from '../models';
// @ts-ignore
import type { CreateEmployeeDevelopmentPathCycleDto } from '../models';
// @ts-ignore
import type { CreateEmployeeDevelopmentPathsCyclesResponseDto } from '../models';
// @ts-ignore
import type { DevelopmentPathCycleStateChangeDto } from '../models';
// @ts-ignore
import type { DevelopmentPathCycleStateChangeResultDto } from '../models';
// @ts-ignore
import type { DevelopmentPlanInitiationStatusDto } from '../models';
// @ts-ignore
import type { EmployeeDevelopmentPathCycleDto } from '../models';
// @ts-ignore
import type { EmployeeDevelopmentPathCyclesDto } from '../models';
// @ts-ignore
import type { EmployeeIndividualDevelopmentPathDto } from '../models';
// @ts-ignore
import type { EmployeeIndividualDevelopmentPathStatusDto } from '../models';
// @ts-ignore
import type { EmployeeProfileRoleDto } from '../models';
// @ts-ignore
import type { IndividualDevelopmentPathIdentifiersDto } from '../models';
// @ts-ignore
import type { InlineObject1Dto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { LanguageDto } from '../models';
// @ts-ignore
import type { RestoreDevelopmentPlanResultDto } from '../models';
// @ts-ignore
import type { UpdateCompetencyCompletionDto } from '../models';
// @ts-ignore
import type { UpdateDevelopmentPathCycleEditModeRequestDto } from '../models';
// @ts-ignore
import type { UpdateDevelopmentPathCycleState400ResponseDto } from '../models';
// @ts-ignore
import type { UpdateDevelopmentPathCycleStateDto } from '../models';
// @ts-ignore
import type { UpdateEmployeeDevelopmentPathCycleDto } from '../models';
// @ts-ignore
import type { UpdateEmployeeIndividualDevelopmentPathDto } from '../models';
/**
 * EmployeeDevelopmentPathApi - axios parameter creator
 * @export
 */
export const EmployeeDevelopmentPathApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Archive accepted individual development paths
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveAccepted: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees/individual-paths/archive-accepted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change acceptance status for individual development path
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {ChangeEmployeeIndividualDevelopmentPathAcceptanceStatusDto} changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto Employee individual development path acceptance status change request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAcceptanceStatusForIndividualDevelopmentPath: async (employeeId: string, developmentPathCycleId: number, individualPathId: string, changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto: ChangeEmployeeIndividualDevelopmentPathAcceptanceStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('changeAcceptanceStatusForIndividualDevelopmentPath', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('changeAcceptanceStatusForIndividualDevelopmentPath', 'developmentPathCycleId', developmentPathCycleId)
            // verify required parameter 'individualPathId' is not null or undefined
            assertParamExists('changeAcceptanceStatusForIndividualDevelopmentPath', 'individualPathId', individualPathId)
            // verify required parameter 'changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto' is not null or undefined
            assertParamExists('changeAcceptanceStatusForIndividualDevelopmentPath', 'changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto', changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}/individual-paths/{individualPathId}/acceptance-status`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)))
                .replace(`{${"individualPathId"}}`, encodeURIComponent(String(individualPathId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create competency development path within individual development path
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {CreateCompetencyDevelopmentPathDto} createCompetencyDevelopmentPathDto Create competency development path request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDevelopmentPathCompetency: async (employeeId: string, developmentPathCycleId: number, individualPathId: string, createCompetencyDevelopmentPathDto: CreateCompetencyDevelopmentPathDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('createDevelopmentPathCompetency', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('createDevelopmentPathCompetency', 'developmentPathCycleId', developmentPathCycleId)
            // verify required parameter 'individualPathId' is not null or undefined
            assertParamExists('createDevelopmentPathCompetency', 'individualPathId', individualPathId)
            // verify required parameter 'createCompetencyDevelopmentPathDto' is not null or undefined
            assertParamExists('createDevelopmentPathCompetency', 'createCompetencyDevelopmentPathDto', createCompetencyDevelopmentPathDto)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}/individual-paths/{individualPathId}/competencies`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)))
                .replace(`{${"individualPathId"}}`, encodeURIComponent(String(individualPathId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompetencyDevelopmentPathDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zakłada cały plan rozwoju w JEDNEJ transakcji: cykl, indywidualną ścieżkę i czat planu. Wcześniej robiły to dwa osobne wywołania (cykl, potem init ścieżki) i przerwanie między nimi zostawiało cykl bez ścieżki - pracownika, który nie mógł ani dodać kroku, ani użyć czatu, ani założyć nowego planu (limit jednego aktywnego cyklu). Dlatego odpowiedź zwraca komplet identyfikatorów i front nie dowołuje już nic po tym wywołaniu.
         * @summary Create development plan (cycle + individual path + chat)
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {CreateEmployeeDevelopmentPathCycleDto} createEmployeeDevelopmentPathCycleDto Create development path cycle request
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmployeeDevelopmentPathsCycles: async (employeeId: string, role: EmployeeProfileRoleDto, createEmployeeDevelopmentPathCycleDto: CreateEmployeeDevelopmentPathCycleDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('createEmployeeDevelopmentPathsCycles', 'employeeId', employeeId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('createEmployeeDevelopmentPathsCycles', 'role', role)
            // verify required parameter 'createEmployeeDevelopmentPathCycleDto' is not null or undefined
            assertParamExists('createEmployeeDevelopmentPathsCycles', 'createEmployeeDevelopmentPathCycleDto', createEmployeeDevelopmentPathCycleDto)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeeDevelopmentPathCycleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete Development\'s path competency
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {number} competencyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDevelopmentPathCompetency: async (employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('deleteDevelopmentPathCompetency', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('deleteDevelopmentPathCompetency', 'developmentPathCycleId', developmentPathCycleId)
            // verify required parameter 'individualPathId' is not null or undefined
            assertParamExists('deleteDevelopmentPathCompetency', 'individualPathId', individualPathId)
            // verify required parameter 'competencyId' is not null or undefined
            assertParamExists('deleteDevelopmentPathCompetency', 'competencyId', competencyId)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}/individual-paths/{individualPathId}/competencies/{competencyId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)))
                .replace(`{${"individualPathId"}}`, encodeURIComponent(String(individualPathId)))
                .replace(`{${"competencyId"}}`, encodeURIComponent(String(competencyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete individual development path
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndividualDevelopmentPath: async (employeeId: string, developmentPathCycleId: number, individualPathId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('deleteIndividualDevelopmentPath', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('deleteIndividualDevelopmentPath', 'developmentPathCycleId', developmentPathCycleId)
            // verify required parameter 'individualPathId' is not null or undefined
            assertParamExists('deleteIndividualDevelopmentPath', 'individualPathId', individualPathId)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}/individual-paths/{individualPathId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)))
                .replace(`{${"individualPathId"}}`, encodeURIComponent(String(individualPathId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zwraca aktywny cykl rozwoju pracownika wraz z planem (individualDevelopmentPaths). 404 gdy brak aktywnego cyklu.
         * @summary Get active development path cycle preview
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveDevelopmentPathCycle: async (employeeId: string, role: EmployeeProfileRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getActiveDevelopmentPathCycle', 'employeeId', employeeId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('getActiveDevelopmentPathCycle', 'role', role)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/active`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get available development paths
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableIndividualDevelopmentPaths: async (employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getAvailableIndividualDevelopmentPaths', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('getAvailableIndividualDevelopmentPaths', 'developmentPathCycleId', developmentPathCycleId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('getAvailableIndividualDevelopmentPaths', 'role', role)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}/individual-paths`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get development path cycle state change
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentPathCycleStateChanges: async (employeeId: string, developmentPathCycleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getDevelopmentPathCycleStateChanges', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('getDevelopmentPathCycleStateChanges', 'developmentPathCycleId', developmentPathCycleId)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}/states-changes-history`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Informuje, czy plan rozwoju pracownika czeka na zainicjowanie przez przełożonego (P1) — tj. istnieje otwarte zadanie inicjacji przypisane do przełożonego. Steruje pustym stanem widoku „Mój rozwój\".
         * @summary Get development plan initiation status
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentPlanInitiationStatus: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getDevelopmentPlanInitiationStatus', 'employeeId', employeeId)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/initiation-status`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get development path cycle
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeDevelopmentPathCycle: async (employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getEmployeeDevelopmentPathCycle', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('getEmployeeDevelopmentPathCycle', 'developmentPathCycleId', developmentPathCycleId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('getEmployeeDevelopmentPathCycle', 'role', role)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get development paths cycles
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {boolean} [onlyTest] Jeśli true, zwraca wyłącznie cykle testowe (tester w panelu admina). Domyślnie/false: tylko cykle realne (profil pracownika).
         * @param {number} [cycleId] Opcjonalny filtr do jednego cyklu. Gdy podany, zwracany jest tylko ten cykl wraz z planem (individualDevelopmentPaths). Bez niego: lista cykli bez planu.
         * @param {boolean} [active] Filtr aktywności cyklu (active &#x3D; stan !&#x3D; EMPLOYEE_DEVELOPMENT_PATH_COMPLETED). true &#x3D; aktywne, false &#x3D; zakończone (historyczne), brak &#x3D; wszystkie. Ignorowane gdy podano cycleId.
         * @param {number} [page] Numer strony (0-based). Paginacja włącza się tylko gdy podano page i pageSize; w przeciwnym razie zwracana jest pełna (posortowana) lista. Ignorowane gdy podano cycleId.
         * @param {number} [pageSize] Rozmiar strony. Wymagany razem z page, by włączyć paginację. Ignorowane gdy podano cycleId.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeDevelopmentPathsCycles: async (employeeId: string, role: EmployeeProfileRoleDto, onlyTest?: boolean, cycleId?: number, active?: boolean, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getEmployeeDevelopmentPathsCycles', 'employeeId', employeeId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('getEmployeeDevelopmentPathsCycles', 'role', role)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (onlyTest !== undefined) {
                localVarQueryParameter['onlyTest'] = onlyTest;
            }

            if (cycleId !== undefined) {
                localVarQueryParameter['cycleId'] = cycleId;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get individual development path
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualDevelopmentPath: async (employeeId: string, developmentPathCycleId: number, individualPathId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getIndividualDevelopmentPath', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('getIndividualDevelopmentPath', 'developmentPathCycleId', developmentPathCycleId)
            // verify required parameter 'individualPathId' is not null or undefined
            assertParamExists('getIndividualDevelopmentPath', 'individualPathId', individualPathId)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}/individual-paths/{individualPathId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)))
                .replace(`{${"individualPathId"}}`, encodeURIComponent(String(individualPathId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get individual development path status
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualDevelopmentPathStatus: async (employeeId: string, developmentPathCycleId: number, individualPathId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getIndividualDevelopmentPathStatus', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('getIndividualDevelopmentPathStatus', 'developmentPathCycleId', developmentPathCycleId)
            // verify required parameter 'individualPathId' is not null or undefined
            assertParamExists('getIndividualDevelopmentPathStatus', 'individualPathId', individualPathId)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}/individual-paths/{individualPathId}/status`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)))
                .replace(`{${"individualPathId"}}`, encodeURIComponent(String(individualPathId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Idempotentne: jeśli cykl ma już ścieżkę, zwraca jej identyfikatory (dokładając czat dla roli, gdy go brakuje) zamiast zakładać drugą. Plan zakłada się przez POST development-paths-cycles - to wywołanie zostaje dla testera planów i jako naprawa cyklu bez ścieżki.
         * @summary Initialize individual development path
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {EmployeeProfileRoleDto} role 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initIndividualDevelopmentPath: async (employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('initIndividualDevelopmentPath', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('initIndividualDevelopmentPath', 'developmentPathCycleId', developmentPathCycleId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('initIndividualDevelopmentPath', 'role', role)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}/individual-paths`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Przywraca plan historyczny do stanu sprzed archiwizacji, żeby pracownik mógł na nim dalej pracować. Dozwolone WYŁĄCZNIE gdy kampania planu jest tą, która obecnie obejmuje pracownika — dzięki temu po cofnięciu pomyłki admina (usunięcie SAP z kampanii zadaniowej) pracownik wraca do kampanii ogólnej i odzyskuje swój wcześniejszy plan. Konflikt z istniejącym aktywnym planem albo niepasująca kampania kończą się 409.
         * @summary Restore an archived development plan
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreArchivedDevelopmentPathCycle: async (employeeId: string, developmentPathCycleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('restoreArchivedDevelopmentPathCycle', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('restoreArchivedDevelopmentPathCycle', 'developmentPathCycleId', developmentPathCycleId)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}/restore`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark competency development path as completed or not completed
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {number} competencyId 
         * @param {UpdateCompetencyCompletionDto} updateCompetencyCompletionDto Update competency completion flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevelopmentPathCompetencyCompletion: async (employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, updateCompetencyCompletionDto: UpdateCompetencyCompletionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateDevelopmentPathCompetencyCompletion', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('updateDevelopmentPathCompetencyCompletion', 'developmentPathCycleId', developmentPathCycleId)
            // verify required parameter 'individualPathId' is not null or undefined
            assertParamExists('updateDevelopmentPathCompetencyCompletion', 'individualPathId', individualPathId)
            // verify required parameter 'competencyId' is not null or undefined
            assertParamExists('updateDevelopmentPathCompetencyCompletion', 'competencyId', competencyId)
            // verify required parameter 'updateCompetencyCompletionDto' is not null or undefined
            assertParamExists('updateDevelopmentPathCompetencyCompletion', 'updateCompetencyCompletionDto', updateCompetencyCompletionDto)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}/individual-paths/{individualPathId}/competencies/{competencyId}/completion`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)))
                .replace(`{${"individualPathId"}}`, encodeURIComponent(String(individualPathId)))
                .replace(`{${"competencyId"}}`, encodeURIComponent(String(competencyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCompetencyCompletionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * JAIN-288 - edits a step in place so the changelog records a single STEP_UPDATED entry instead of delete + add.
         * @summary Update competency development path content (milestone, dates, actions)
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {number} competencyId 
         * @param {CreateCompetencyDevelopmentPathDto} createCompetencyDevelopmentPathDto Create competency development path request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevelopmentPathCompetencyContent: async (employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, createCompetencyDevelopmentPathDto: CreateCompetencyDevelopmentPathDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateDevelopmentPathCompetencyContent', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('updateDevelopmentPathCompetencyContent', 'developmentPathCycleId', developmentPathCycleId)
            // verify required parameter 'individualPathId' is not null or undefined
            assertParamExists('updateDevelopmentPathCompetencyContent', 'individualPathId', individualPathId)
            // verify required parameter 'competencyId' is not null or undefined
            assertParamExists('updateDevelopmentPathCompetencyContent', 'competencyId', competencyId)
            // verify required parameter 'createCompetencyDevelopmentPathDto' is not null or undefined
            assertParamExists('updateDevelopmentPathCompetencyContent', 'createCompetencyDevelopmentPathDto', createCompetencyDevelopmentPathDto)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}/individual-paths/{individualPathId}/competencies/{competencyId}/content`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)))
                .replace(`{${"individualPathId"}}`, encodeURIComponent(String(individualPathId)))
                .replace(`{${"competencyId"}}`, encodeURIComponent(String(competencyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompetencyDevelopmentPathDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update development path cycle edit mode
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {UpdateDevelopmentPathCycleEditModeRequestDto} updateDevelopmentPathCycleEditModeRequestDto Update development path cycle request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevelopmentPathCycleEditMode: async (employeeId: string, developmentPathCycleId: number, updateDevelopmentPathCycleEditModeRequestDto: UpdateDevelopmentPathCycleEditModeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateDevelopmentPathCycleEditMode', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('updateDevelopmentPathCycleEditMode', 'developmentPathCycleId', developmentPathCycleId)
            // verify required parameter 'updateDevelopmentPathCycleEditModeRequestDto' is not null or undefined
            assertParamExists('updateDevelopmentPathCycleEditMode', 'updateDevelopmentPathCycleEditModeRequestDto', updateDevelopmentPathCycleEditModeRequestDto)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}/update-edit-mode`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDevelopmentPathCycleEditModeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update development path cycle state
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {EmployeeProfileRoleDto} role 
         * @param {UpdateDevelopmentPathCycleStateDto} updateDevelopmentPathCycleStateDto Update development path cycle state request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevelopmentPathCycleState: async (employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, updateDevelopmentPathCycleStateDto: UpdateDevelopmentPathCycleStateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateDevelopmentPathCycleState', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('updateDevelopmentPathCycleState', 'developmentPathCycleId', developmentPathCycleId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('updateDevelopmentPathCycleState', 'role', role)
            // verify required parameter 'updateDevelopmentPathCycleStateDto' is not null or undefined
            assertParamExists('updateDevelopmentPathCycleState', 'updateDevelopmentPathCycleStateDto', updateDevelopmentPathCycleStateDto)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}/update-state`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDevelopmentPathCycleStateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update development path cycle
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {UpdateEmployeeDevelopmentPathCycleDto} updateEmployeeDevelopmentPathCycleDto Update development path cycle request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeDevelopmentPathCycle: async (employeeId: string, developmentPathCycleId: number, updateEmployeeDevelopmentPathCycleDto: UpdateEmployeeDevelopmentPathCycleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateEmployeeDevelopmentPathCycle', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('updateEmployeeDevelopmentPathCycle', 'developmentPathCycleId', developmentPathCycleId)
            // verify required parameter 'updateEmployeeDevelopmentPathCycleDto' is not null or undefined
            assertParamExists('updateEmployeeDevelopmentPathCycle', 'updateEmployeeDevelopmentPathCycleDto', updateEmployeeDevelopmentPathCycleDto)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeDevelopmentPathCycleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update individual development\'s path competency
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {number} competencyId 
         * @param {UpdateEmployeeIndividualDevelopmentPathDto} updateEmployeeIndividualDevelopmentPathDto Employee individual development path update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIndividualPathCompetency: async (employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, updateEmployeeIndividualDevelopmentPathDto: UpdateEmployeeIndividualDevelopmentPathDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateIndividualPathCompetency', 'employeeId', employeeId)
            // verify required parameter 'developmentPathCycleId' is not null or undefined
            assertParamExists('updateIndividualPathCompetency', 'developmentPathCycleId', developmentPathCycleId)
            // verify required parameter 'individualPathId' is not null or undefined
            assertParamExists('updateIndividualPathCompetency', 'individualPathId', individualPathId)
            // verify required parameter 'competencyId' is not null or undefined
            assertParamExists('updateIndividualPathCompetency', 'competencyId', competencyId)
            // verify required parameter 'updateEmployeeIndividualDevelopmentPathDto' is not null or undefined
            assertParamExists('updateIndividualPathCompetency', 'updateEmployeeIndividualDevelopmentPathDto', updateEmployeeIndividualDevelopmentPathDto)
            const localVarPath = `/api/v2/employees/{employeeId}/development-cycles/{developmentPathCycleId}/individual-paths/{individualPathId}/competencies/{competencyId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"developmentPathCycleId"}}`, encodeURIComponent(String(developmentPathCycleId)))
                .replace(`{${"individualPathId"}}`, encodeURIComponent(String(individualPathId)))
                .replace(`{${"competencyId"}}`, encodeURIComponent(String(competencyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeIndividualDevelopmentPathDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeDevelopmentPathApi - functional programming interface
 * @export
 */
export const EmployeeDevelopmentPathApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeDevelopmentPathApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Archive accepted individual development paths
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveAccepted(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveAccepted(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.archiveAccepted']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change acceptance status for individual development path
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {ChangeEmployeeIndividualDevelopmentPathAcceptanceStatusDto} changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto Employee individual development path acceptance status change request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeAcceptanceStatusForIndividualDevelopmentPath(employeeId: string, developmentPathCycleId: number, individualPathId: string, changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto: ChangeEmployeeIndividualDevelopmentPathAcceptanceStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeAcceptanceStatusForIndividualDevelopmentPath(employeeId, developmentPathCycleId, individualPathId, changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.changeAcceptanceStatusForIndividualDevelopmentPath']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create competency development path within individual development path
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {CreateCompetencyDevelopmentPathDto} createCompetencyDevelopmentPathDto Create competency development path request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDevelopmentPathCompetency(employeeId: string, developmentPathCycleId: number, individualPathId: string, createCompetencyDevelopmentPathDto: CreateCompetencyDevelopmentPathDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCompetencyDevelopmentPathResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDevelopmentPathCompetency(employeeId, developmentPathCycleId, individualPathId, createCompetencyDevelopmentPathDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.createDevelopmentPathCompetency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zakłada cały plan rozwoju w JEDNEJ transakcji: cykl, indywidualną ścieżkę i czat planu. Wcześniej robiły to dwa osobne wywołania (cykl, potem init ścieżki) i przerwanie między nimi zostawiało cykl bez ścieżki - pracownika, który nie mógł ani dodać kroku, ani użyć czatu, ani założyć nowego planu (limit jednego aktywnego cyklu). Dlatego odpowiedź zwraca komplet identyfikatorów i front nie dowołuje już nic po tym wywołaniu.
         * @summary Create development plan (cycle + individual path + chat)
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {CreateEmployeeDevelopmentPathCycleDto} createEmployeeDevelopmentPathCycleDto Create development path cycle request
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmployeeDevelopmentPathsCycles(employeeId: string, role: EmployeeProfileRoleDto, createEmployeeDevelopmentPathCycleDto: CreateEmployeeDevelopmentPathCycleDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEmployeeDevelopmentPathsCyclesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmployeeDevelopmentPathsCycles(employeeId, role, createEmployeeDevelopmentPathCycleDto, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.createEmployeeDevelopmentPathsCycles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete Development\'s path competency
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {number} competencyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDevelopmentPathCompetency(employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDevelopmentPathCompetency(employeeId, developmentPathCycleId, individualPathId, competencyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.deleteDevelopmentPathCompetency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete individual development path
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIndividualDevelopmentPath(employeeId: string, developmentPathCycleId: number, individualPathId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIndividualDevelopmentPath(employeeId, developmentPathCycleId, individualPathId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.deleteIndividualDevelopmentPath']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zwraca aktywny cykl rozwoju pracownika wraz z planem (individualDevelopmentPaths). 404 gdy brak aktywnego cyklu.
         * @summary Get active development path cycle preview
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveDevelopmentPathCycle(employeeId: string, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDevelopmentPathCycleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveDevelopmentPathCycle(employeeId, role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.getActiveDevelopmentPathCycle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get available development paths
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableIndividualDevelopmentPaths(employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailableIndividualCompetencyDevelopmentPathsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableIndividualDevelopmentPaths(employeeId, developmentPathCycleId, role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.getAvailableIndividualDevelopmentPaths']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get development path cycle state change
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevelopmentPathCycleStateChanges(employeeId: string, developmentPathCycleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DevelopmentPathCycleStateChangeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevelopmentPathCycleStateChanges(employeeId, developmentPathCycleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.getDevelopmentPathCycleStateChanges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Informuje, czy plan rozwoju pracownika czeka na zainicjowanie przez przełożonego (P1) — tj. istnieje otwarte zadanie inicjacji przypisane do przełożonego. Steruje pustym stanem widoku „Mój rozwój\".
         * @summary Get development plan initiation status
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevelopmentPlanInitiationStatus(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentPlanInitiationStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevelopmentPlanInitiationStatus(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.getDevelopmentPlanInitiationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get development path cycle
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeDevelopmentPathCycle(employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDevelopmentPathCycleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeDevelopmentPathCycle(employeeId, developmentPathCycleId, role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.getEmployeeDevelopmentPathCycle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get development paths cycles
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {boolean} [onlyTest] Jeśli true, zwraca wyłącznie cykle testowe (tester w panelu admina). Domyślnie/false: tylko cykle realne (profil pracownika).
         * @param {number} [cycleId] Opcjonalny filtr do jednego cyklu. Gdy podany, zwracany jest tylko ten cykl wraz z planem (individualDevelopmentPaths). Bez niego: lista cykli bez planu.
         * @param {boolean} [active] Filtr aktywności cyklu (active &#x3D; stan !&#x3D; EMPLOYEE_DEVELOPMENT_PATH_COMPLETED). true &#x3D; aktywne, false &#x3D; zakończone (historyczne), brak &#x3D; wszystkie. Ignorowane gdy podano cycleId.
         * @param {number} [page] Numer strony (0-based). Paginacja włącza się tylko gdy podano page i pageSize; w przeciwnym razie zwracana jest pełna (posortowana) lista. Ignorowane gdy podano cycleId.
         * @param {number} [pageSize] Rozmiar strony. Wymagany razem z page, by włączyć paginację. Ignorowane gdy podano cycleId.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeDevelopmentPathsCycles(employeeId: string, role: EmployeeProfileRoleDto, onlyTest?: boolean, cycleId?: number, active?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDevelopmentPathCyclesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeDevelopmentPathsCycles(employeeId, role, onlyTest, cycleId, active, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.getEmployeeDevelopmentPathsCycles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get individual development path
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIndividualDevelopmentPath(employeeId: string, developmentPathCycleId: number, individualPathId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeIndividualDevelopmentPathDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIndividualDevelopmentPath(employeeId, developmentPathCycleId, individualPathId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.getIndividualDevelopmentPath']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get individual development path status
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIndividualDevelopmentPathStatus(employeeId: string, developmentPathCycleId: number, individualPathId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeIndividualDevelopmentPathStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIndividualDevelopmentPathStatus(employeeId, developmentPathCycleId, individualPathId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.getIndividualDevelopmentPathStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Idempotentne: jeśli cykl ma już ścieżkę, zwraca jej identyfikatory (dokładając czat dla roli, gdy go brakuje) zamiast zakładać drugą. Plan zakłada się przez POST development-paths-cycles - to wywołanie zostaje dla testera planów i jako naprawa cyklu bez ścieżki.
         * @summary Initialize individual development path
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {EmployeeProfileRoleDto} role 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initIndividualDevelopmentPath(employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualDevelopmentPathIdentifiersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initIndividualDevelopmentPath(employeeId, developmentPathCycleId, role, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.initIndividualDevelopmentPath']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Przywraca plan historyczny do stanu sprzed archiwizacji, żeby pracownik mógł na nim dalej pracować. Dozwolone WYŁĄCZNIE gdy kampania planu jest tą, która obecnie obejmuje pracownika — dzięki temu po cofnięciu pomyłki admina (usunięcie SAP z kampanii zadaniowej) pracownik wraca do kampanii ogólnej i odzyskuje swój wcześniejszy plan. Konflikt z istniejącym aktywnym planem albo niepasująca kampania kończą się 409.
         * @summary Restore an archived development plan
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreArchivedDevelopmentPathCycle(employeeId: string, developmentPathCycleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestoreDevelopmentPlanResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreArchivedDevelopmentPathCycle(employeeId, developmentPathCycleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.restoreArchivedDevelopmentPathCycle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark competency development path as completed or not completed
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {number} competencyId 
         * @param {UpdateCompetencyCompletionDto} updateCompetencyCompletionDto Update competency completion flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDevelopmentPathCompetencyCompletion(employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, updateCompetencyCompletionDto: UpdateCompetencyCompletionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDevelopmentPathCompetencyCompletion(employeeId, developmentPathCycleId, individualPathId, competencyId, updateCompetencyCompletionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.updateDevelopmentPathCompetencyCompletion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * JAIN-288 - edits a step in place so the changelog records a single STEP_UPDATED entry instead of delete + add.
         * @summary Update competency development path content (milestone, dates, actions)
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {number} competencyId 
         * @param {CreateCompetencyDevelopmentPathDto} createCompetencyDevelopmentPathDto Create competency development path request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDevelopmentPathCompetencyContent(employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, createCompetencyDevelopmentPathDto: CreateCompetencyDevelopmentPathDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDevelopmentPathCompetencyContent(employeeId, developmentPathCycleId, individualPathId, competencyId, createCompetencyDevelopmentPathDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.updateDevelopmentPathCompetencyContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update development path cycle edit mode
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {UpdateDevelopmentPathCycleEditModeRequestDto} updateDevelopmentPathCycleEditModeRequestDto Update development path cycle request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDevelopmentPathCycleEditMode(employeeId: string, developmentPathCycleId: number, updateDevelopmentPathCycleEditModeRequestDto: UpdateDevelopmentPathCycleEditModeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDevelopmentPathCycleEditMode(employeeId, developmentPathCycleId, updateDevelopmentPathCycleEditModeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.updateDevelopmentPathCycleEditMode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update development path cycle state
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {EmployeeProfileRoleDto} role 
         * @param {UpdateDevelopmentPathCycleStateDto} updateDevelopmentPathCycleStateDto Update development path cycle state request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDevelopmentPathCycleState(employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, updateDevelopmentPathCycleStateDto: UpdateDevelopmentPathCycleStateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentPathCycleStateChangeResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDevelopmentPathCycleState(employeeId, developmentPathCycleId, role, updateDevelopmentPathCycleStateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.updateDevelopmentPathCycleState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update development path cycle
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {UpdateEmployeeDevelopmentPathCycleDto} updateEmployeeDevelopmentPathCycleDto Update development path cycle request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmployeeDevelopmentPathCycle(employeeId: string, developmentPathCycleId: number, updateEmployeeDevelopmentPathCycleDto: UpdateEmployeeDevelopmentPathCycleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmployeeDevelopmentPathCycle(employeeId, developmentPathCycleId, updateEmployeeDevelopmentPathCycleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.updateEmployeeDevelopmentPathCycle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update individual development\'s path competency
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {number} competencyId 
         * @param {UpdateEmployeeIndividualDevelopmentPathDto} updateEmployeeIndividualDevelopmentPathDto Employee individual development path update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIndividualPathCompetency(employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, updateEmployeeIndividualDevelopmentPathDto: UpdateEmployeeIndividualDevelopmentPathDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIndividualPathCompetency(employeeId, developmentPathCycleId, individualPathId, competencyId, updateEmployeeIndividualDevelopmentPathDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeDevelopmentPathApi.updateIndividualPathCompetency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeeDevelopmentPathApi - factory interface
 * @export
 */
export const EmployeeDevelopmentPathApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeDevelopmentPathApiFp(configuration)
    return {
        /**
         * 
         * @summary Archive accepted individual development paths
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveAccepted(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.archiveAccepted(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change acceptance status for individual development path
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {ChangeEmployeeIndividualDevelopmentPathAcceptanceStatusDto} changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto Employee individual development path acceptance status change request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAcceptanceStatusForIndividualDevelopmentPath(employeeId: string, developmentPathCycleId: number, individualPathId: string, changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto: ChangeEmployeeIndividualDevelopmentPathAcceptanceStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeAcceptanceStatusForIndividualDevelopmentPath(employeeId, developmentPathCycleId, individualPathId, changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create competency development path within individual development path
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {CreateCompetencyDevelopmentPathDto} createCompetencyDevelopmentPathDto Create competency development path request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDevelopmentPathCompetency(employeeId: string, developmentPathCycleId: number, individualPathId: string, createCompetencyDevelopmentPathDto: CreateCompetencyDevelopmentPathDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateCompetencyDevelopmentPathResponseDto> {
            return localVarFp.createDevelopmentPathCompetency(employeeId, developmentPathCycleId, individualPathId, createCompetencyDevelopmentPathDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Zakłada cały plan rozwoju w JEDNEJ transakcji: cykl, indywidualną ścieżkę i czat planu. Wcześniej robiły to dwa osobne wywołania (cykl, potem init ścieżki) i przerwanie między nimi zostawiało cykl bez ścieżki - pracownika, który nie mógł ani dodać kroku, ani użyć czatu, ani założyć nowego planu (limit jednego aktywnego cyklu). Dlatego odpowiedź zwraca komplet identyfikatorów i front nie dowołuje już nic po tym wywołaniu.
         * @summary Create development plan (cycle + individual path + chat)
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {CreateEmployeeDevelopmentPathCycleDto} createEmployeeDevelopmentPathCycleDto Create development path cycle request
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmployeeDevelopmentPathsCycles(employeeId: string, role: EmployeeProfileRoleDto, createEmployeeDevelopmentPathCycleDto: CreateEmployeeDevelopmentPathCycleDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateEmployeeDevelopmentPathsCyclesResponseDto> {
            return localVarFp.createEmployeeDevelopmentPathsCycles(employeeId, role, createEmployeeDevelopmentPathCycleDto, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete Development\'s path competency
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {number} competencyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDevelopmentPathCompetency(employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDevelopmentPathCompetency(employeeId, developmentPathCycleId, individualPathId, competencyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete individual development path
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndividualDevelopmentPath(employeeId: string, developmentPathCycleId: number, individualPathId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteIndividualDevelopmentPath(employeeId, developmentPathCycleId, individualPathId, options).then((request) => request(axios, basePath));
        },
        /**
         * Zwraca aktywny cykl rozwoju pracownika wraz z planem (individualDevelopmentPaths). 404 gdy brak aktywnego cyklu.
         * @summary Get active development path cycle preview
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveDevelopmentPathCycle(employeeId: string, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeDevelopmentPathCycleDto> {
            return localVarFp.getActiveDevelopmentPathCycle(employeeId, role, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get available development paths
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableIndividualDevelopmentPaths(employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<AvailableIndividualCompetencyDevelopmentPathsDto> {
            return localVarFp.getAvailableIndividualDevelopmentPaths(employeeId, developmentPathCycleId, role, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get development path cycle state change
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentPathCycleStateChanges(employeeId: string, developmentPathCycleId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DevelopmentPathCycleStateChangeDto>> {
            return localVarFp.getDevelopmentPathCycleStateChanges(employeeId, developmentPathCycleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Informuje, czy plan rozwoju pracownika czeka na zainicjowanie przez przełożonego (P1) — tj. istnieje otwarte zadanie inicjacji przypisane do przełożonego. Steruje pustym stanem widoku „Mój rozwój\".
         * @summary Get development plan initiation status
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentPlanInitiationStatus(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentPlanInitiationStatusDto> {
            return localVarFp.getDevelopmentPlanInitiationStatus(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get development path cycle
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeDevelopmentPathCycle(employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeDevelopmentPathCycleDto> {
            return localVarFp.getEmployeeDevelopmentPathCycle(employeeId, developmentPathCycleId, role, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get development paths cycles
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {boolean} [onlyTest] Jeśli true, zwraca wyłącznie cykle testowe (tester w panelu admina). Domyślnie/false: tylko cykle realne (profil pracownika).
         * @param {number} [cycleId] Opcjonalny filtr do jednego cyklu. Gdy podany, zwracany jest tylko ten cykl wraz z planem (individualDevelopmentPaths). Bez niego: lista cykli bez planu.
         * @param {boolean} [active] Filtr aktywności cyklu (active &#x3D; stan !&#x3D; EMPLOYEE_DEVELOPMENT_PATH_COMPLETED). true &#x3D; aktywne, false &#x3D; zakończone (historyczne), brak &#x3D; wszystkie. Ignorowane gdy podano cycleId.
         * @param {number} [page] Numer strony (0-based). Paginacja włącza się tylko gdy podano page i pageSize; w przeciwnym razie zwracana jest pełna (posortowana) lista. Ignorowane gdy podano cycleId.
         * @param {number} [pageSize] Rozmiar strony. Wymagany razem z page, by włączyć paginację. Ignorowane gdy podano cycleId.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeDevelopmentPathsCycles(employeeId: string, role: EmployeeProfileRoleDto, onlyTest?: boolean, cycleId?: number, active?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeDevelopmentPathCyclesDto> {
            return localVarFp.getEmployeeDevelopmentPathsCycles(employeeId, role, onlyTest, cycleId, active, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get individual development path
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualDevelopmentPath(employeeId: string, developmentPathCycleId: number, individualPathId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeIndividualDevelopmentPathDto> {
            return localVarFp.getIndividualDevelopmentPath(employeeId, developmentPathCycleId, individualPathId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get individual development path status
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualDevelopmentPathStatus(employeeId: string, developmentPathCycleId: number, individualPathId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeIndividualDevelopmentPathStatusDto> {
            return localVarFp.getIndividualDevelopmentPathStatus(employeeId, developmentPathCycleId, individualPathId, options).then((request) => request(axios, basePath));
        },
        /**
         * Idempotentne: jeśli cykl ma już ścieżkę, zwraca jej identyfikatory (dokładając czat dla roli, gdy go brakuje) zamiast zakładać drugą. Plan zakłada się przez POST development-paths-cycles - to wywołanie zostaje dla testera planów i jako naprawa cyklu bez ścieżki.
         * @summary Initialize individual development path
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {EmployeeProfileRoleDto} role 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initIndividualDevelopmentPath(employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<IndividualDevelopmentPathIdentifiersDto> {
            return localVarFp.initIndividualDevelopmentPath(employeeId, developmentPathCycleId, role, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Przywraca plan historyczny do stanu sprzed archiwizacji, żeby pracownik mógł na nim dalej pracować. Dozwolone WYŁĄCZNIE gdy kampania planu jest tą, która obecnie obejmuje pracownika — dzięki temu po cofnięciu pomyłki admina (usunięcie SAP z kampanii zadaniowej) pracownik wraca do kampanii ogólnej i odzyskuje swój wcześniejszy plan. Konflikt z istniejącym aktywnym planem albo niepasująca kampania kończą się 409.
         * @summary Restore an archived development plan
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreArchivedDevelopmentPathCycle(employeeId: string, developmentPathCycleId: number, options?: RawAxiosRequestConfig): AxiosPromise<RestoreDevelopmentPlanResultDto> {
            return localVarFp.restoreArchivedDevelopmentPathCycle(employeeId, developmentPathCycleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark competency development path as completed or not completed
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {number} competencyId 
         * @param {UpdateCompetencyCompletionDto} updateCompetencyCompletionDto Update competency completion flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevelopmentPathCompetencyCompletion(employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, updateCompetencyCompletionDto: UpdateCompetencyCompletionDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDevelopmentPathCompetencyCompletion(employeeId, developmentPathCycleId, individualPathId, competencyId, updateCompetencyCompletionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * JAIN-288 - edits a step in place so the changelog records a single STEP_UPDATED entry instead of delete + add.
         * @summary Update competency development path content (milestone, dates, actions)
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {number} competencyId 
         * @param {CreateCompetencyDevelopmentPathDto} createCompetencyDevelopmentPathDto Create competency development path request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevelopmentPathCompetencyContent(employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, createCompetencyDevelopmentPathDto: CreateCompetencyDevelopmentPathDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDevelopmentPathCompetencyContent(employeeId, developmentPathCycleId, individualPathId, competencyId, createCompetencyDevelopmentPathDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update development path cycle edit mode
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {UpdateDevelopmentPathCycleEditModeRequestDto} updateDevelopmentPathCycleEditModeRequestDto Update development path cycle request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevelopmentPathCycleEditMode(employeeId: string, developmentPathCycleId: number, updateDevelopmentPathCycleEditModeRequestDto: UpdateDevelopmentPathCycleEditModeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDevelopmentPathCycleEditMode(employeeId, developmentPathCycleId, updateDevelopmentPathCycleEditModeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update development path cycle state
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {EmployeeProfileRoleDto} role 
         * @param {UpdateDevelopmentPathCycleStateDto} updateDevelopmentPathCycleStateDto Update development path cycle state request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevelopmentPathCycleState(employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, updateDevelopmentPathCycleStateDto: UpdateDevelopmentPathCycleStateDto, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentPathCycleStateChangeResultDto> {
            return localVarFp.updateDevelopmentPathCycleState(employeeId, developmentPathCycleId, role, updateDevelopmentPathCycleStateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update development path cycle
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {UpdateEmployeeDevelopmentPathCycleDto} updateEmployeeDevelopmentPathCycleDto Update development path cycle request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeDevelopmentPathCycle(employeeId: string, developmentPathCycleId: number, updateEmployeeDevelopmentPathCycleDto: UpdateEmployeeDevelopmentPathCycleDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEmployeeDevelopmentPathCycle(employeeId, developmentPathCycleId, updateEmployeeDevelopmentPathCycleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update individual development\'s path competency
         * @param {string} employeeId 
         * @param {number} developmentPathCycleId Development path cycle id
         * @param {string} individualPathId Individual development path id
         * @param {number} competencyId 
         * @param {UpdateEmployeeIndividualDevelopmentPathDto} updateEmployeeIndividualDevelopmentPathDto Employee individual development path update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIndividualPathCompetency(employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, updateEmployeeIndividualDevelopmentPathDto: UpdateEmployeeIndividualDevelopmentPathDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateIndividualPathCompetency(employeeId, developmentPathCycleId, individualPathId, competencyId, updateEmployeeIndividualDevelopmentPathDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeDevelopmentPathApi - interface
 * @export
 * @interface EmployeeDevelopmentPathApi
 */
export interface EmployeeDevelopmentPathApiInterface {
    /**
     * 
     * @summary Archive accepted individual development paths
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    archiveAccepted(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Change acceptance status for individual development path
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {ChangeEmployeeIndividualDevelopmentPathAcceptanceStatusDto} changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto Employee individual development path acceptance status change request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    changeAcceptanceStatusForIndividualDevelopmentPath(employeeId: string, developmentPathCycleId: number, individualPathId: string, changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto: ChangeEmployeeIndividualDevelopmentPathAcceptanceStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Create competency development path within individual development path
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {CreateCompetencyDevelopmentPathDto} createCompetencyDevelopmentPathDto Create competency development path request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    createDevelopmentPathCompetency(employeeId: string, developmentPathCycleId: number, individualPathId: string, createCompetencyDevelopmentPathDto: CreateCompetencyDevelopmentPathDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateCompetencyDevelopmentPathResponseDto>;

    /**
     * Zakłada cały plan rozwoju w JEDNEJ transakcji: cykl, indywidualną ścieżkę i czat planu. Wcześniej robiły to dwa osobne wywołania (cykl, potem init ścieżki) i przerwanie między nimi zostawiało cykl bez ścieżki - pracownika, który nie mógł ani dodać kroku, ani użyć czatu, ani założyć nowego planu (limit jednego aktywnego cyklu). Dlatego odpowiedź zwraca komplet identyfikatorów i front nie dowołuje już nic po tym wywołaniu.
     * @summary Create development plan (cycle + individual path + chat)
     * @param {string} employeeId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {CreateEmployeeDevelopmentPathCycleDto} createEmployeeDevelopmentPathCycleDto Create development path cycle request
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    createEmployeeDevelopmentPathsCycles(employeeId: string, role: EmployeeProfileRoleDto, createEmployeeDevelopmentPathCycleDto: CreateEmployeeDevelopmentPathCycleDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateEmployeeDevelopmentPathsCyclesResponseDto>;

    /**
     * Delete Development\'s path competency
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {number} competencyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    deleteDevelopmentPathCompetency(employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete individual development path
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    deleteIndividualDevelopmentPath(employeeId: string, developmentPathCycleId: number, individualPathId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Zwraca aktywny cykl rozwoju pracownika wraz z planem (individualDevelopmentPaths). 404 gdy brak aktywnego cyklu.
     * @summary Get active development path cycle preview
     * @param {string} employeeId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    getActiveDevelopmentPathCycle(employeeId: string, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeDevelopmentPathCycleDto>;

    /**
     * 
     * @summary Get available development paths
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {EmployeeProfileRoleDto} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    getAvailableIndividualDevelopmentPaths(employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<AvailableIndividualCompetencyDevelopmentPathsDto>;

    /**
     * 
     * @summary Get development path cycle state change
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    getDevelopmentPathCycleStateChanges(employeeId: string, developmentPathCycleId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DevelopmentPathCycleStateChangeDto>>;

    /**
     * Informuje, czy plan rozwoju pracownika czeka na zainicjowanie przez przełożonego (P1) — tj. istnieje otwarte zadanie inicjacji przypisane do przełożonego. Steruje pustym stanem widoku „Mój rozwój\".
     * @summary Get development plan initiation status
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    getDevelopmentPlanInitiationStatus(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentPlanInitiationStatusDto>;

    /**
     * 
     * @summary Get development path cycle
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {EmployeeProfileRoleDto} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    getEmployeeDevelopmentPathCycle(employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeDevelopmentPathCycleDto>;

    /**
     * 
     * @summary Get development paths cycles
     * @param {string} employeeId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {boolean} [onlyTest] Jeśli true, zwraca wyłącznie cykle testowe (tester w panelu admina). Domyślnie/false: tylko cykle realne (profil pracownika).
     * @param {number} [cycleId] Opcjonalny filtr do jednego cyklu. Gdy podany, zwracany jest tylko ten cykl wraz z planem (individualDevelopmentPaths). Bez niego: lista cykli bez planu.
     * @param {boolean} [active] Filtr aktywności cyklu (active &#x3D; stan !&#x3D; EMPLOYEE_DEVELOPMENT_PATH_COMPLETED). true &#x3D; aktywne, false &#x3D; zakończone (historyczne), brak &#x3D; wszystkie. Ignorowane gdy podano cycleId.
     * @param {number} [page] Numer strony (0-based). Paginacja włącza się tylko gdy podano page i pageSize; w przeciwnym razie zwracana jest pełna (posortowana) lista. Ignorowane gdy podano cycleId.
     * @param {number} [pageSize] Rozmiar strony. Wymagany razem z page, by włączyć paginację. Ignorowane gdy podano cycleId.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    getEmployeeDevelopmentPathsCycles(employeeId: string, role: EmployeeProfileRoleDto, onlyTest?: boolean, cycleId?: number, active?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeDevelopmentPathCyclesDto>;

    /**
     * 
     * @summary Get individual development path
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    getIndividualDevelopmentPath(employeeId: string, developmentPathCycleId: number, individualPathId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeIndividualDevelopmentPathDto>;

    /**
     * 
     * @summary Get individual development path status
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    getIndividualDevelopmentPathStatus(employeeId: string, developmentPathCycleId: number, individualPathId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeIndividualDevelopmentPathStatusDto>;

    /**
     * Idempotentne: jeśli cykl ma już ścieżkę, zwraca jej identyfikatory (dokładając czat dla roli, gdy go brakuje) zamiast zakładać drugą. Plan zakłada się przez POST development-paths-cycles - to wywołanie zostaje dla testera planów i jako naprawa cyklu bez ścieżki.
     * @summary Initialize individual development path
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {EmployeeProfileRoleDto} role 
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    initIndividualDevelopmentPath(employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<IndividualDevelopmentPathIdentifiersDto>;

    /**
     * Przywraca plan historyczny do stanu sprzed archiwizacji, żeby pracownik mógł na nim dalej pracować. Dozwolone WYŁĄCZNIE gdy kampania planu jest tą, która obecnie obejmuje pracownika — dzięki temu po cofnięciu pomyłki admina (usunięcie SAP z kampanii zadaniowej) pracownik wraca do kampanii ogólnej i odzyskuje swój wcześniejszy plan. Konflikt z istniejącym aktywnym planem albo niepasująca kampania kończą się 409.
     * @summary Restore an archived development plan
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    restoreArchivedDevelopmentPathCycle(employeeId: string, developmentPathCycleId: number, options?: RawAxiosRequestConfig): AxiosPromise<RestoreDevelopmentPlanResultDto>;

    /**
     * 
     * @summary Mark competency development path as completed or not completed
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {number} competencyId 
     * @param {UpdateCompetencyCompletionDto} updateCompetencyCompletionDto Update competency completion flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    updateDevelopmentPathCompetencyCompletion(employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, updateCompetencyCompletionDto: UpdateCompetencyCompletionDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * JAIN-288 - edits a step in place so the changelog records a single STEP_UPDATED entry instead of delete + add.
     * @summary Update competency development path content (milestone, dates, actions)
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {number} competencyId 
     * @param {CreateCompetencyDevelopmentPathDto} createCompetencyDevelopmentPathDto Create competency development path request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    updateDevelopmentPathCompetencyContent(employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, createCompetencyDevelopmentPathDto: CreateCompetencyDevelopmentPathDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update development path cycle edit mode
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {UpdateDevelopmentPathCycleEditModeRequestDto} updateDevelopmentPathCycleEditModeRequestDto Update development path cycle request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    updateDevelopmentPathCycleEditMode(employeeId: string, developmentPathCycleId: number, updateDevelopmentPathCycleEditModeRequestDto: UpdateDevelopmentPathCycleEditModeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update development path cycle state
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {EmployeeProfileRoleDto} role 
     * @param {UpdateDevelopmentPathCycleStateDto} updateDevelopmentPathCycleStateDto Update development path cycle state request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    updateDevelopmentPathCycleState(employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, updateDevelopmentPathCycleStateDto: UpdateDevelopmentPathCycleStateDto, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentPathCycleStateChangeResultDto>;

    /**
     * 
     * @summary Update development path cycle
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {UpdateEmployeeDevelopmentPathCycleDto} updateEmployeeDevelopmentPathCycleDto Update development path cycle request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    updateEmployeeDevelopmentPathCycle(employeeId: string, developmentPathCycleId: number, updateEmployeeDevelopmentPathCycleDto: UpdateEmployeeDevelopmentPathCycleDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update individual development\'s path competency
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {number} competencyId 
     * @param {UpdateEmployeeIndividualDevelopmentPathDto} updateEmployeeIndividualDevelopmentPathDto Employee individual development path update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApiInterface
     */
    updateIndividualPathCompetency(employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, updateEmployeeIndividualDevelopmentPathDto: UpdateEmployeeIndividualDevelopmentPathDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * EmployeeDevelopmentPathApi - object-oriented interface
 * @export
 * @class EmployeeDevelopmentPathApi
 * @extends {BaseAPI}
 */
export class EmployeeDevelopmentPathApi extends BaseAPI implements EmployeeDevelopmentPathApiInterface {
    /**
     * 
     * @summary Archive accepted individual development paths
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public archiveAccepted(options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).archiveAccepted(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change acceptance status for individual development path
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {ChangeEmployeeIndividualDevelopmentPathAcceptanceStatusDto} changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto Employee individual development path acceptance status change request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public changeAcceptanceStatusForIndividualDevelopmentPath(employeeId: string, developmentPathCycleId: number, individualPathId: string, changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto: ChangeEmployeeIndividualDevelopmentPathAcceptanceStatusDto, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).changeAcceptanceStatusForIndividualDevelopmentPath(employeeId, developmentPathCycleId, individualPathId, changeEmployeeIndividualDevelopmentPathAcceptanceStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create competency development path within individual development path
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {CreateCompetencyDevelopmentPathDto} createCompetencyDevelopmentPathDto Create competency development path request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public createDevelopmentPathCompetency(employeeId: string, developmentPathCycleId: number, individualPathId: string, createCompetencyDevelopmentPathDto: CreateCompetencyDevelopmentPathDto, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).createDevelopmentPathCompetency(employeeId, developmentPathCycleId, individualPathId, createCompetencyDevelopmentPathDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zakłada cały plan rozwoju w JEDNEJ transakcji: cykl, indywidualną ścieżkę i czat planu. Wcześniej robiły to dwa osobne wywołania (cykl, potem init ścieżki) i przerwanie między nimi zostawiało cykl bez ścieżki - pracownika, który nie mógł ani dodać kroku, ani użyć czatu, ani założyć nowego planu (limit jednego aktywnego cyklu). Dlatego odpowiedź zwraca komplet identyfikatorów i front nie dowołuje już nic po tym wywołaniu.
     * @summary Create development plan (cycle + individual path + chat)
     * @param {string} employeeId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {CreateEmployeeDevelopmentPathCycleDto} createEmployeeDevelopmentPathCycleDto Create development path cycle request
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public createEmployeeDevelopmentPathsCycles(employeeId: string, role: EmployeeProfileRoleDto, createEmployeeDevelopmentPathCycleDto: CreateEmployeeDevelopmentPathCycleDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).createEmployeeDevelopmentPathsCycles(employeeId, role, createEmployeeDevelopmentPathCycleDto, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete Development\'s path competency
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {number} competencyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public deleteDevelopmentPathCompetency(employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).deleteDevelopmentPathCompetency(employeeId, developmentPathCycleId, individualPathId, competencyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete individual development path
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public deleteIndividualDevelopmentPath(employeeId: string, developmentPathCycleId: number, individualPathId: string, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).deleteIndividualDevelopmentPath(employeeId, developmentPathCycleId, individualPathId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zwraca aktywny cykl rozwoju pracownika wraz z planem (individualDevelopmentPaths). 404 gdy brak aktywnego cyklu.
     * @summary Get active development path cycle preview
     * @param {string} employeeId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public getActiveDevelopmentPathCycle(employeeId: string, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).getActiveDevelopmentPathCycle(employeeId, role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get available development paths
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {EmployeeProfileRoleDto} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public getAvailableIndividualDevelopmentPaths(employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).getAvailableIndividualDevelopmentPaths(employeeId, developmentPathCycleId, role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get development path cycle state change
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public getDevelopmentPathCycleStateChanges(employeeId: string, developmentPathCycleId: number, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).getDevelopmentPathCycleStateChanges(employeeId, developmentPathCycleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Informuje, czy plan rozwoju pracownika czeka na zainicjowanie przez przełożonego (P1) — tj. istnieje otwarte zadanie inicjacji przypisane do przełożonego. Steruje pustym stanem widoku „Mój rozwój\".
     * @summary Get development plan initiation status
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public getDevelopmentPlanInitiationStatus(employeeId: string, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).getDevelopmentPlanInitiationStatus(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get development path cycle
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {EmployeeProfileRoleDto} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public getEmployeeDevelopmentPathCycle(employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).getEmployeeDevelopmentPathCycle(employeeId, developmentPathCycleId, role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get development paths cycles
     * @param {string} employeeId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {boolean} [onlyTest] Jeśli true, zwraca wyłącznie cykle testowe (tester w panelu admina). Domyślnie/false: tylko cykle realne (profil pracownika).
     * @param {number} [cycleId] Opcjonalny filtr do jednego cyklu. Gdy podany, zwracany jest tylko ten cykl wraz z planem (individualDevelopmentPaths). Bez niego: lista cykli bez planu.
     * @param {boolean} [active] Filtr aktywności cyklu (active &#x3D; stan !&#x3D; EMPLOYEE_DEVELOPMENT_PATH_COMPLETED). true &#x3D; aktywne, false &#x3D; zakończone (historyczne), brak &#x3D; wszystkie. Ignorowane gdy podano cycleId.
     * @param {number} [page] Numer strony (0-based). Paginacja włącza się tylko gdy podano page i pageSize; w przeciwnym razie zwracana jest pełna (posortowana) lista. Ignorowane gdy podano cycleId.
     * @param {number} [pageSize] Rozmiar strony. Wymagany razem z page, by włączyć paginację. Ignorowane gdy podano cycleId.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public getEmployeeDevelopmentPathsCycles(employeeId: string, role: EmployeeProfileRoleDto, onlyTest?: boolean, cycleId?: number, active?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).getEmployeeDevelopmentPathsCycles(employeeId, role, onlyTest, cycleId, active, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get individual development path
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public getIndividualDevelopmentPath(employeeId: string, developmentPathCycleId: number, individualPathId: string, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).getIndividualDevelopmentPath(employeeId, developmentPathCycleId, individualPathId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get individual development path status
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public getIndividualDevelopmentPathStatus(employeeId: string, developmentPathCycleId: number, individualPathId: string, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).getIndividualDevelopmentPathStatus(employeeId, developmentPathCycleId, individualPathId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Idempotentne: jeśli cykl ma już ścieżkę, zwraca jej identyfikatory (dokładając czat dla roli, gdy go brakuje) zamiast zakładać drugą. Plan zakłada się przez POST development-paths-cycles - to wywołanie zostaje dla testera planów i jako naprawa cyklu bez ścieżki.
     * @summary Initialize individual development path
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {EmployeeProfileRoleDto} role 
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public initIndividualDevelopmentPath(employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).initIndividualDevelopmentPath(employeeId, developmentPathCycleId, role, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Przywraca plan historyczny do stanu sprzed archiwizacji, żeby pracownik mógł na nim dalej pracować. Dozwolone WYŁĄCZNIE gdy kampania planu jest tą, która obecnie obejmuje pracownika — dzięki temu po cofnięciu pomyłki admina (usunięcie SAP z kampanii zadaniowej) pracownik wraca do kampanii ogólnej i odzyskuje swój wcześniejszy plan. Konflikt z istniejącym aktywnym planem albo niepasująca kampania kończą się 409.
     * @summary Restore an archived development plan
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public restoreArchivedDevelopmentPathCycle(employeeId: string, developmentPathCycleId: number, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).restoreArchivedDevelopmentPathCycle(employeeId, developmentPathCycleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark competency development path as completed or not completed
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {number} competencyId 
     * @param {UpdateCompetencyCompletionDto} updateCompetencyCompletionDto Update competency completion flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public updateDevelopmentPathCompetencyCompletion(employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, updateCompetencyCompletionDto: UpdateCompetencyCompletionDto, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).updateDevelopmentPathCompetencyCompletion(employeeId, developmentPathCycleId, individualPathId, competencyId, updateCompetencyCompletionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * JAIN-288 - edits a step in place so the changelog records a single STEP_UPDATED entry instead of delete + add.
     * @summary Update competency development path content (milestone, dates, actions)
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {number} competencyId 
     * @param {CreateCompetencyDevelopmentPathDto} createCompetencyDevelopmentPathDto Create competency development path request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public updateDevelopmentPathCompetencyContent(employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, createCompetencyDevelopmentPathDto: CreateCompetencyDevelopmentPathDto, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).updateDevelopmentPathCompetencyContent(employeeId, developmentPathCycleId, individualPathId, competencyId, createCompetencyDevelopmentPathDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update development path cycle edit mode
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {UpdateDevelopmentPathCycleEditModeRequestDto} updateDevelopmentPathCycleEditModeRequestDto Update development path cycle request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public updateDevelopmentPathCycleEditMode(employeeId: string, developmentPathCycleId: number, updateDevelopmentPathCycleEditModeRequestDto: UpdateDevelopmentPathCycleEditModeRequestDto, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).updateDevelopmentPathCycleEditMode(employeeId, developmentPathCycleId, updateDevelopmentPathCycleEditModeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update development path cycle state
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {EmployeeProfileRoleDto} role 
     * @param {UpdateDevelopmentPathCycleStateDto} updateDevelopmentPathCycleStateDto Update development path cycle state request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public updateDevelopmentPathCycleState(employeeId: string, developmentPathCycleId: number, role: EmployeeProfileRoleDto, updateDevelopmentPathCycleStateDto: UpdateDevelopmentPathCycleStateDto, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).updateDevelopmentPathCycleState(employeeId, developmentPathCycleId, role, updateDevelopmentPathCycleStateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update development path cycle
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {UpdateEmployeeDevelopmentPathCycleDto} updateEmployeeDevelopmentPathCycleDto Update development path cycle request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public updateEmployeeDevelopmentPathCycle(employeeId: string, developmentPathCycleId: number, updateEmployeeDevelopmentPathCycleDto: UpdateEmployeeDevelopmentPathCycleDto, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).updateEmployeeDevelopmentPathCycle(employeeId, developmentPathCycleId, updateEmployeeDevelopmentPathCycleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update individual development\'s path competency
     * @param {string} employeeId 
     * @param {number} developmentPathCycleId Development path cycle id
     * @param {string} individualPathId Individual development path id
     * @param {number} competencyId 
     * @param {UpdateEmployeeIndividualDevelopmentPathDto} updateEmployeeIndividualDevelopmentPathDto Employee individual development path update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDevelopmentPathApi
     */
    public updateIndividualPathCompetency(employeeId: string, developmentPathCycleId: number, individualPathId: string, competencyId: number, updateEmployeeIndividualDevelopmentPathDto: UpdateEmployeeIndividualDevelopmentPathDto, options?: RawAxiosRequestConfig) {
        return EmployeeDevelopmentPathApiFp(this.configuration).updateIndividualPathCompetency(employeeId, developmentPathCycleId, individualPathId, competencyId, updateEmployeeIndividualDevelopmentPathDto, options).then((request) => request(this.axios, this.basePath));
    }
}

